import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'stripHtmlPipe'
})
export class StripHtmlPipe implements PipeTransform {
	public transform(inputString: string): string {
		if (inputString !== '') {
			// Parsed in an inert DOMParser document rather than through innerHTML on a live-document
			// element, so markup in inputString cannot execute or load resources while it is stripped.
			const inertDocument = new DOMParser().parseFromString(inputString ?? '', 'text/html');
			return inertDocument.body.textContent || '';
		}
		return inputString;
	}
}
